<p-dialog header="View Name" [(visible)]="visible" (onHide)="close.emit('close')"  [style]="{width: '30vw'}">
  <div class="datagrid-form">
    <div class="datagrid__fields">
      <div class="form-field-box">
        <label for="name">View Name <span class="required"><i class="fa fa-asterisk"></i></span></label>
        <input [(ngModel)]="advFilterService.currentView.name" type="text" class="form-control" placeholder="Name" />
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button [disabled]="!advFilterService.currentView.name || advFilterService.currentView.name.length > 50" (click)="onCreate($event)" type="button" class="btn-bg">Create</button>
  </ng-template>
</p-dialog>
